import React, { useContext } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import { ProfileContext } from "../../../Services/ProfileProvider";
import moment from "moment";
import { Link } from "react-router-dom";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";
import countryName from "../../../Component/SidebarComponent/UserKyc/countryName.json"

const UserProfile = () => {

	const { userDetails } = useContext(ProfileContext);
	console.log("🚀 ~ UserProfile ~ userDetails:", userDetails)
	const KycStatus = userDetails?.kycVerified;
	const countryFlag = countryName.filter(flag => flag.name === userDetails?.country)[0];


	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container container-custom" >
							<div className="row g-3" >

								<div className="col-lg-12" >
									<div className="card bal_card_main" >
										<div class="card-body ">
											<h4 class=""> Your personal information </h4>
											<p>
												Here you can view and change your personal information on our platform.
												Please note that the details should be correct and up-to-date.
											</p>
											<form className="mt-4 mt-xl-5" >
												<div class="row mb-3">
													<div class="col-xxl-3 col-lg-4">
														<div class="avatar-preview">
															<img src={ApiConfig?.url + userDetails.user_image || "/assets/images/NEWUSER.jpeg"} alt="Profile"
																onError={(e) => {
																	e.target.onerror = null;
																	e.target.src = "/assets/images/NEWUSER.jpeg";
																}}
															/>
														</div>
													</div>
													<div class="col-xxl-9 col-lg-8">
														<div class="mb-3">
															<label class="form-label mb-0" for="exampleInputName">Name</label>
															<h6>{userDetails?.name || "------"}</h6></div>
														<div class="mb-3">
															<label class="form-label mb-0" for="exampleInputName">Email</label>
															<h6>{userDetails?.emailId}</h6></div>
													</div>
												</div>
												<div class="react-bootstrap-table">
													<table class="table">
														<tbody>
															<tr>
																<td> Phone Number  </td>
																<td><b> {countryFlag?.dial_code || ""} {userDetails?.phone_number || "------"} </b></td>
															</tr>
															<tr>
																<td> Date Of Birth</td>
																<td><b>  {moment(userDetails?.dob).format("Do MMMM YYYY")} </b></td>
															</tr>
															<tr>
																<td> Verification status </td>
																<td><b class={KycStatus === 0 ? "text-warning" : KycStatus === 1 ? "text-warning" : KycStatus === 2 ? "text-success" : "text-danger"}>
																	{KycStatus === 0 ? "Update Kyc" : KycStatus === 1 ? "Kyc Pending" : KycStatus === 2 ? "Verified" : "Rejected"}
																</b> </td>
															</tr>
															<tr>
																<td> Username	 </td>
																<td><b>  {userDetails?.name || "------"} </b></td>
															</tr>
															<tr>
																<td> Activation Date </td>
																<td><b> {moment(userDetails?.activation_Date).format("DD/MM/YYYY")} <br /> {moment(userDetails?.activation_Date).format("HH:mm:ss")} </b></td>
															</tr>
														</tbody>
													</table>
												</div>
												<Link class="btn btn-primary-light w-100" to="/edit_profile">  EDIT PROFILE  </Link>
											</form>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default UserProfile


